export const UPDATE_CAMPAIGNS_ANALYTICS__STATE = "UPDATE_CAMPAIGNS_ANALYTICS__STATE"
export const UPDATE_LIVE_CAMPAIGNS__STATE = "UPDATE_LIVE_CAMPAIGNS__STATE"
export const UPDATE_HISTORIC_CAMPAIGNS_STATE = "UPDATE_HISTORIC_CAMPAIGNS_STATE"
export const UPDATE_COMPONENT_STATE = "UPDATE_COMPONENT_STATE"
export const REMOVE_UPDATED_FLAG = "REMOVE_UPDATED_FLAG"